import { render, staticRenderFns } from "./relationGrowthModel.vue?vue&type=template&id=15f844f8&scoped=true"
import script from "./relationGrowthModel.vue?vue&type=script&lang=js"
export * from "./relationGrowthModel.vue?vue&type=script&lang=js"
import style0 from "./relationGrowthModel.vue?vue&type=style&index=0&id=15f844f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f844f8",
  null
  
)

export default component.exports